import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const DispatchSubscriberExportsAccessRight = {
  VIEW_EXPORT_DISPATCH_SUBSCRIBERS_LIST: () => true,
  CREATE_EXPORT_DISPATCH_SUBSCRIBERS: () => true,
} satisfies Record<string, AuthenticationAccessRight>;
